// extracted by mini-css-extract-plugin
module.exports = {"rounds":"Rounds_rounds__2Vo2I"};